// https://api.nylas.com/oauth/authorize?client_id=d3yu5lovbvujuy6vzk7o8zr6i&response_type=token&scopes=calendar&login_hint=matt@onflourish.com&redirect_uri=http://localhost:3000/admin/integrations/calendar&state

import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import queryString from 'query-string'

import classyLogo from './../../../assets/images/classy_logo.svg'

import { Button, Chip, CircularProgress, TextField, Typography } from "@mui/material";

import { API, Auth } from 'aws-amplify';

import { useAppSelector, useAppDispatch } from "../../../hooks";
import { createClassyConnection, getActiveClassyConnections } from '../../../managers/redux/slices/organization';
import { getAvailableCalendars } from '../../../managers/redux/slices/calendar';
import { reloadAuthAccount } from '../../../managers/redux/slices/authAccount';
import { toast } from 'react-toastify';

export default function ClassyIntegration(props: any) {

    const history = useHistory()
    const dispatch = useAppDispatch()

    const [setupClassyConnection, setSetupClassyConnection] = useState<boolean>(false)
    const [apiClientID, setApiClientID] = useState<string | null>(null)
    const [apiClientSecret, setApiClientSecret] = useState<string | null>(null)
    const [classyOrganizationID, setClassyOrganizationID] = useState<string | null>(null)

    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)
    const authAccount = useAppSelector(state => state.authAccount.data)
    const cognitoData = useAppSelector(state => state.authAccount.cognitoData)
    const activeClassyConnections = useAppSelector(state => state.organization.activeClassyConnection)

    useEffect(() => {
        (async () => {
            if (cognitoData) {
                await dispatch(getActiveClassyConnections())
            } else {
                await dispatch(reloadAuthAccount())
                await dispatch(getActiveClassyConnections())
            }
        })()
    }, [])

    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-12 d-flex flex-row justify-content-between align-items-center mb-5">
                    <div className="d-flex flex-row justify-content-center align-items-center">
                        <img src={classyLogo} style={{ width: 200, height: 60, objectFit: 'contain' }} />
                        {
                            activeClassyConnections && activeClassyConnections.length > 0 &&
                            <Chip label="Connected" color="success" className="ms-3" />
                        }
                    </div>
                    <Button variant="outlined" className="px-3" onClick={() => history.push('/admin/integrations')}>Back to Integrations</Button>
                </div>
                {
                    activeClassyConnections && activeClassyConnections.length > 0 ?
                        <div className="col-12">
                            <div className="border rounded p-5 bg-white d-flex flex-row justify-content-between align-items-center">
                                <Typography variant="body1">You have at least one active API connection to Classy. If you need to adjust this information, contact Support.</Typography>
                                <Button variant="contained" onClick={() => {
                                    // @ts-ignore
                                    window.Tawk_API.maximize()
                                }}>Contact Support</Button>
                            </div>
                        </div>
                        :
                        <div className="col-12">
                            <div className="border rounded p-5 bg-white row">
                                <div className="col-12 col-lg-9 d-flex flex-row justify-content-center align-items-center">
                                    <Typography variant="body1">Get started using Classy in Latent by providing a Classy API Client ID and API Client Secret. Click the button to begin the process of authorizing Latent to manage your Classy Campaigns.</Typography>
                                </div>
                                <div className="col-12 col-lg-3 d-flex flex-row justify-content-center justify-content-lg-end align-items-center">
                                    <Button variant="contained" onClick={() => setSetupClassyConnection(true)}>Add Classy Connection</Button>
                                </div>
                            </div>
                        </div>
                }
                {
                    setupClassyConnection &&
                    <div className="col-12">
                        <div className="p-5 border rounded bg-white my-5 row">
                            <div className="col-12 d-flex flex-row justify-content-start align-items-center my-3">
                                <Typography variant="h3">Add a new connection</Typography>
                            </div>
                            <div className="col-12 d-flex flex-row justify-content-start align-items-center my-3">
                                <TextField fullWidth label="Classy Organization ID" value={classyOrganizationID} onChange={(e) => setClassyOrganizationID(e.target.value)} />
                            </div>
                            <div className="col-12 col-lg-6 d-flex flex-row justify-content-start align-items-center my-3">
                                <TextField fullWidth label="API Client ID" value={apiClientID} onChange={(e) => setApiClientID(e.target.value)} />
                            </div>
                            <div className="col-12 col-lg-6 d-flex flex-row justify-content-start align-items-center my-3">
                                <TextField fullWidth label="API Client Secret" value={apiClientSecret} onChange={(e) => setApiClientSecret(e.target.value)} />
                            </div>
                            <div className="col-12 col-lg-6 d-flex flex-row justify-content-start align-items-center my-3">
                                <Button variant="contained" onClick={async () => {
                                    if (apiClientID && apiClientSecret && classyOrganizationID) {
                                        const response = await dispatch(createClassyConnection({ apiClientID, apiClientSecret, classyOrganizationID }))
                                        console.log(response)
                                        if (response.payload && response.payload.activeConnections && response.payload.activeConnections.length > 0) {
                                            setSetupClassyConnection(false)
                                        }
                                    } else {
                                        toast.error('You must enter a valid Client ID, Client Secret, and Organizaiton ID.', { containerId: 'main' })
                                    }
                                }}>Add Connection</Button>
                            </div>
                        </div>
                    </div>
                }
                {
                    activeClassyConnections && activeClassyConnections.length > 0 ?
                        <div className="row">
                            <Typography variant="h3" className="mt-5 mb-3">Classy Connections</Typography>
                            {
                                activeClassyConnections.map((connection: any) => {
                                    return (
                                        <div className="col-12">
                                            <div className="d-flex flex-row justify-content-between align-items-center border rounded bg-white px-5 py-3 mb-3 w-100">
                                                <Typography>{connection.classyApiClientID}</Typography>
                                                {
                                                    connection.active &&
                                                    <Chip label="Active" color="success" />
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        : activeClassyConnections && activeClassyConnections.length == 0 ?
                            < div className="col-12 mt-5 d-flex flex-column justify-content-start align-items-center w-100">
                                <Typography className="mt-3">No active Classy connections</Typography>
                            </div>
                            :
                            <div className="col-12 mt-5 d-flex flex-column justify-content-start align-items-center w-100">
                                <CircularProgress />
                                <Typography className="mt-3">Loading available calendars...</Typography>
                            </div>
                }
            </div>
        </div >
    )
}